import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { default as SwitchMUI } from "@mui/material/Switch";

const Switch = ({ disabled, label, value, ...props }: any) => (
  <FormGroup>
    <FormControlLabel
      label={label}
      disabled={disabled}
      sx={{ justifyContent: "center" }}
      control={<SwitchMUI {...props} />}
    />
  </FormGroup>
);

export default Switch;
